import { FavoriteIcon } from 'components/icons';

/**
 * Favorite Editable Cell Renderer
 * @param {{value:*, row:*, column:*, updateTogglesData:Function}} param0
 * @returns
 */
export default function FavoriteToggleCell({
  value,
  row,
  column,
  updateTogglesData,
}) {
  const handleToggleFavorite = () => {
    updateTogglesData({
      rowIndex: row.index,
      columnId: column.id,
      value: !!!value, // Reverse current bool value
      segmentId: row.original.id,
    });
  };

  return (
    <button
      aria-label="Toggle favorite"
      aria-pressed={value}
      onClick={handleToggleFavorite}
      className="block outline-none focus:outline-none"
    >
      <FavoriteIcon
        className={'w-5 h-5 text-segments-accent-color-orange cursor-pointer'}
        selected={value}
      />
    </button>
  );
}
